module.exports = __webpack_public_path__ + "img/38.7efb4b28.jpg";